import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Agentic Atoms';
const DEFAULT_DESCRIPTION = 'Agentic Atoms builds custom AI chatbots, AI-powered websites, AI voice agents, AI receptionists, and AI sales agents for small and mid-sized businesses. From AI chatbot builders to full workflow automation — get a working AI system in 30 days. Book a free discovery call.';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_stylish-agentic/artifacts/lev4hvvo_image.png';
const BASE_URL = 'https://agenticatoms.com';
const DEFAULT_KEYWORDS = 'AI chatbot builder, AI website builder, AI voice agent, AI receptionist, AI sales agent, custom AI apps, AI chatbot for business, AI automation, AI consulting, build AI chatbot for website, AI receptionist for local business, AI appointment booking, AI lead generation';

const SITE_ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Agentic Atoms",
  "url": "https://agenticatoms.com",
  "logo": "https://customer-assets.emergentagent.com/job_stylish-agentic/artifacts/lev4hvvo_image.png",
  "description": "Agentic Atoms builds custom AI chatbots, AI voice agents, AI receptionists, AI sales agents, and AI-powered websites for small and mid-sized businesses.",
  "address": { "@type": "PostalAddress", "streetAddress": "5830 E 2nd St, Ste 7000 #30038", "addressLocality": "Casper", "addressRegion": "WY", "postalCode": "82609", "addressCountry": "US" },
  "contactPoint": { "@type": "ContactPoint", "email": "connect@agenticatoms.com", "telephone": "+1-227-241-6372", "contactType": "sales" },
  "sameAs": ["https://www.linkedin.com/company/agentic-atoms/", "https://www.instagram.com/agenticatoms/"]
};

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  noindex = false,
  jsonLd,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | AI Chatbot Builder, AI Websites & AI Voice Agents for Business`;
  const canonicalUrl = `${BASE_URL}${path}`;

  // Merge Organization schema into every page
  const allSchemas = [];
  allSchemas.push(SITE_ORGANIZATION_SCHEMA);
  if (jsonLd) {
    if (Array.isArray(jsonLd)) {
      // Filter out duplicate Organization schemas from page-level jsonLd
      jsonLd.forEach(item => {
        if (item['@type'] !== 'Organization') allSchemas.push(item);
      });
    } else {
      if (jsonLd['@type'] !== 'Organization') allSchemas.push(jsonLd);
    }
  }

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data — separate script tags for each schema */}
      {allSchemas.map((item, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(item)}</script>
      ))}
    </Helmet>
  );
};

export default SEO;
